module.exports = __webpack_public_path__ + "static/media/ic_naver.776b332d.svg";